(() => {
    window.addEventListener('DOMContentLoaded', storeProductInCookie);

    function storeProductInCookie() {
        const productInfo = window.document.querySelector('product-info[data-url]');
        if (!productInfo) return;

        const productHandle = productInfo.getAttribute('data-product-handle');
        if (!productHandle) return;

        let cookieName = 'shopify_recently_viewed';
        let cookieValue = getCookie(cookieName);

        // If products has been already viewed, we remove to keep the visualization order
        if (isProductInCookie(cookieValue, productHandle)) {
            cookieValue = removeProductFromCookie(cookieValue, productHandle);
        }

        cookieValue += (cookieValue ? ',' : '') + productHandle;

        // We have hardocoded a limit of 25 handles in the coockie. If we hit this value, we remove the first in
        cookieValue = removeOldestProductIfNeeded(cookieValue);

        setCookie(cookieName, cookieValue, 30);
    }

    function getCookie(name) {
        let cookieArr = document.cookie.split(';');
        for (let i = 0; i < cookieArr.length; i++) {
            let cookie = cookieArr[i].trim();
            if (cookie.indexOf(name + '=') == 0) {
                return cookie.substring(name.length + 1, cookie.length);
            }
        }
        return '';
    }

    function isProductInCookie(cookieValue, productHandle) {
        return cookieValue.split(',').includes(productHandle);
    }

    function removeProductFromCookie(cookieValue, productHandle) {
        return cookieValue
            .split(',')
            .filter((handle) => handle !== productHandle)
            .join(',');
    }

    function removeOldestProductIfNeeded(cookieValue) {
        let products = cookieValue.split(',');
        if (products.length >= 25) {
            products.shift();
        }
        return products.join(',');
    }

    function setCookie(name, value, days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        let expires = 'expires=' + date.toUTCString();
        let secure = location.protocol === 'https:' ? 'Secure; ' : '';
        let sameSite = 'SameSite=Lax';
        document.cookie = name + '=' + value + ';' + expires + ';path=/; ' + secure + sameSite;
    }
})();
